<div class="right-panel"
     *ngIf="allNetworks.length >0">
  <div class="panel-header">
    <p class="panel-title">Create Roaming Relation</p>
  </div>
  <div class="panel-container">
    <form name="createRP"
          class="createNS"
          #validate="ngForm">

      <div class="createNS-row">
        <label class="widget-create-title">NS
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input class="widget-create-content"
               value="{{nsName}},  {{nsId}}"
               disabled/>
      </div>

      <div class="createNS-row">
        <label class="widget-create-title">Partner NS
          <i class="fa fa-info-circle info-text"></i>
        </label>

        <div class="live-search">
          <ngx-select [allowClear]="true"
                     [items]="allNetworks"
                     (select)="selectedOwner($event)"
                     (remove)="removed($event)">
          </ngx-select>
        </div>

      </div>

      <div class="createNS-row">
        <label class="widget-create-title">Partner NS roles
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input class="checkbox-checked"
               type="checkbox"
               [(ngModel)]="roamingPartnersModel.partnersRole.fNS"
               name="optionPartnerRolesFns"
               (change)="updateModelOnFnsChanged()">fNS

        <input class="margin-left-20 checkbox-checked"
               type="checkbox"
               [(ngModel)]="roamingPartnersModel.partnersRole.sNS"
               name="optionPartnerRolesSns"
               (change)="updateModelOnSnsChanged()">sNS
      </div>

      <div class="createNS-row">
        <label for="ownDevices"
               class="widget-create-title">Allow PRA of own devices
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input class="checkbox-checked"
               type="checkbox"
               id="ownDevices"
               [(ngModel)]="roamingPartnersModel.ownDevices"
               name="ownDevices"
               (change)="updateModelOnOwnPRAChanged()">
      </div>

      <div class="createNS-row">
        <label for="partnerDevice"
               class="widget-create-title">Allow PRA of partner devices
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input class="checkbox-checked"
               type="checkbox"
               id="partnerDevice"
               [(ngModel)]="roamingPartnersModel.partnerDevice"
               name="partnerDevice"
               (change)="updateModelOnPartnerPRAChanged()">
      </div>

      <div class="createNS-row">
        <label for="roamingPolicy"
               class="widget-create-title">Roaming policy type
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <select name="roamingPolicy"
                id="roamingPolicy"
                class="widget-create-content"
                [(ngModel)]="roamingPartnersModel.roamingPolicy"
                required>
          <option value="Unrestricted Peering">Unrestricted Peering</option>
          <option value="Balanced Peering">Balanced Peering</option>
        </select>
      </div>

      <div class="createNS-row">
        <div *ngIf="roamingPartnersModel.roamingPolicy =='Balanced Peering'">
          <div>
            <label for="incomingUL"
                   class="widget-create-title">Incoming UL imbalance tolerance
              <i class="fa fa-info-circle info-text"></i>
            </label>
            <input id="incomingUL"
                   class="widget-create-content"
                   [(ngModel)]="roamingPartnersModel.incomingUL"
                   required
                   name="incomingUL"
                   #incomingUL="ngModel"
                   maxlength="7"
                   pattern="^[1-9][0-9]*$"
                   autocomplete="off">
            <i class="fa fa-check check-input-validation" aria-hidden="true"></i>
            <div [hidden]="incomingUL.valid || incomingUL.pristine"
                 class="alert alert-danger alert-validate">
              <div [hidden]="!incomingUL.hasError('required')">Incoming UL is required</div>
              <div [hidden]="!incomingUL.hasError('pattern')">Incoming UL is invalid</div>
            </div>
          </div>

          <div>
            <label for="outgoingUL"
                   class="widget-create-title">Outgoing UL imbalance tolerance
              <i class="fa fa-info-circle info-text"></i>
            </label>
            <input id="outgoingUL"
                   class="widget-create-content"
                   [(ngModel)]="roamingPartnersModel.outgoingUL"
                   required
                   name="outgoingUL"
                   #outgoingUL="ngModel"
                   maxlength="7"
                   pattern="^[1-9][0-9]*$"
                   autocomplete="off">
            <i class="fa fa-check check-input-validation" aria-hidden="true"></i>
            <div [hidden]="outgoingUL.valid || outgoingUL.pristine"
                 class="alert alert-danger alert-validate">
              <div [hidden]="!outgoingUL.hasError('required')">Outgoing UL is required</div>
              <div [hidden]="!outgoingUL.hasError('pattern')">Outgoing UL is invalid</div>
            </div>
          </div>

          <div>
            <label for="incomingDL"
                   class="widget-create-title">Incoming DL imbalance tolerance
              <i class="fa fa-info-circle info-text"></i>
            </label>
            <input id="incomingDL"
                   class="widget-create-content"
                   [(ngModel)]="roamingPartnersModel.incomingDL"
                   required
                   name="incomingDL"
                   #incomingDL="ngModel"
                   maxlength="7"
                   pattern="^[1-9][0-9]*$"
                   autocomplete="off">
            <i class="fa fa-check check-input-validation" aria-hidden="true"></i>
            <div [hidden]="incomingDL.valid || incomingDL.pristine"
                 class="alert alert-danger alert-validate">
              <div [hidden]="!incomingDL.hasError('required')">Incoming DL is required</div>
              <div [hidden]="!incomingDL.hasError('pattern')">Incoming DL is invalid</div>
            </div>
          </div>

          <div>
            <label for="outgoingDL"
                   class="widget-create-title">Outgoing DL imbalance tolerance
              <i class="fa fa-info-circle info-text"></i>
            </label>
            <input id="outgoingDL"
                   class="widget-create-content"
                   [(ngModel)]="roamingPartnersModel.outgoingDL"
                   required
                   name="outgoingDL"
                   #outgoingDL="ngModel"
                   maxlength="7"
                   pattern="^[1-9][0-9]*$"
                   autocomplete="off">
            <i class="fa fa-check check-input-validation" aria-hidden="true"></i>
            <div [hidden]="outgoingDL.valid || outgoingDL.pristine"
                 class="alert alert-danger alert-validate">
              <div [hidden]="!outgoingDL.hasError('required')">Outgoing DL is required</div>
              <div [hidden]="!outgoingDL.hasError('pattern')">Outgoing DL is invalid</div>
            </div>
          </div>

        </div>
      </div>

      <div class="btn-area">
        <button (click)="backClicked()"
                class="custom-btn">Cancel
        </button>
        <button type="submit"
                class="custom-btn create-btn form-control"
                [ngClass]="{'disable': !isEnable}"
                [disabled]="!validate.valid || !isEnable"
                (click)="save()">Save
        </button>
      </div>

    </form>
  </div>

</div>
